export default __webpack_public_path__ + "static/media/download.be80e05d.svg";